import { Typography } from '@mui/material';
import { theme } from '../../../theme';
import SubAdminTable from './SubAdminTable';
import { ThemeProvider } from '@mui/material/styles';
const SubAdminList = () => {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Sub Admin
      </Typography>
      <SubAdminTable />
    </ThemeProvider>
  );
};
// const WrappedSubAdminList = () => (
//   <ThemeProvider theme={theme}>
//     <SubAdminList />
//   </ThemeProvider>
// );

export default SubAdminList;
